import { createColumnHelper } from "@tanstack/react-table";
import { formatNumberToDisplay } from "@/lib/api/common";
import { ClientOpenPosition } from "@/lib/api/risk/summary";
import moment from "moment-timezone";
import { CommonDestinationTimezone } from "@/lib/utils";

export function getBrokerageTableColumns<T extends ClientOpenPosition>(commodityDisplayName: string, customerNameMap?: Record<string, string>) {
    const columnHelper = createColumnHelper<any>();
    
    return [
        commodityDisplayName === 'Wheat' ? columnHelper.accessor("commodity", {
            id: "commodity",
            header: "Commodity",
            footer: (props: any) => props.column.id,
        }) : null,
        columnHelper.accessor("trading_account", {
            id: "trading_account",
            header: "Trading Account",
        }),
        columnHelper.accessor("customer_id", {
            id: "customer_id",
            header: "Customer",
            ...({
                accessorFn: (row: any) => {
                    return (
                            row.Customer?.long_name || ((row.customer_id && customerNameMap) ? customerNameMap![row.customer_id] : "")
                    )
                }
            }),
        }),
        columnHelper.accessor("enabled", {
            id: "enabled",
            header: "Open",
            filterFn: (row, columnId, filterValue) => {
                if (!filterValue) return true;

                if ('open'.startsWith(filterValue?.toLocaleLowerCase())) {
                    return row.getValue(columnId) === true;
                }
                return 'closed'.startsWith(filterValue?.toLocaleLowerCase()) && row.getValue(columnId) === false;
            },
            cell: (info) => {
                return (
                    <span className="text-gray-600 text-sm">
                        {info.getValue() ? "Open" : "Closed"}
                    </span>
                )
            },
        }),
        columnHelper.accessor("put_or_call", {
            id: "put_or_call",
            header: "Put/Call",
            ...({
                accessorFn: (row: any) => (row.put_or_call === 'P' ? "Put" : row.put_or_call === 'C' ? "Call" : "Future")
            }),
        }),
        columnHelper.accessor("crop_year", {
            id: "crop_year",
            header: "Crop Year",
        }),
        columnHelper.accessor("option_month", {
            id: "option_month",
            header: "Option Month",
        }),
        columnHelper.accessor("long_qty", {
            id: "long_qty",
            header: "Long Qty",
        }),
        columnHelper.accessor("short_qty", {
            id: "short_qty",
            header: "Short Qty",
        }),
        columnHelper.accessor("bushel", {
            id: "bushel",
            header: "Quantity",
            cell: (info) => {
                return (
                    <span className="text-gray-600 text-sm">
                        {formatNumberToDisplay(info.getValue())}
                    </span>
                )
            },
        }),
        columnHelper.accessor("strike_price", {
            id: "strike_price",
            header: "Strike Price",
            cell: (info) => {
                return (
                    <span className="text-gray-600 text-sm">
                        {formatNumberToDisplay(info.getValue())}
                    </span>
                )
            },
        }),
        columnHelper.accessor("price", {
            id: "price",
            header: "Price",
            cell: (info) => {
                return (
                    <span className="text-gray-600 text-sm">
                        {formatNumberToDisplay(info.getValue())}
                    </span>
                )
            },
        }),
        columnHelper.accessor("premium", {
            id: "premium",
            header: "Premium",
            cell: (info) => {
                return (
                    <span className="text-gray-600 text-sm">
                        {formatNumberToDisplay(info.getValue())}
                    </span>
                )
            }
        }),
        columnHelper.accessor("contract", {
            id: "contract",
            header: "Contract",
        }),
        columnHelper.accessor("trader_id", {
            id: "trader_id",
            header: "Trader",
            ...({ accessorFn: (row: any) => row?.Trader?.name || "" })
        }),
    ].filter(Boolean);
}
